<template>
    <v-select v-bind="{ ...attrs_select_common, ...$attrs }" class="rounded-0">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-select>
</template>

<script>
import { attrs_select_common } from "@/assets/variables";

export default {
    props: {
    },
    components: {},
    data: () => {
        return {
            attrs_select_common,
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>